const equal = require('fast-deep-equal');

function matchRequestToMock(request) {
  return function(mock) {
    return matchRequestToMockRequest(request, mock.request);
  }
}

function matchRequestToMockRequest(request, mockRequest) {
  return mockRequest.url === request.url
    && mockRequest.method === request.method
    && (equal(mockRequest.body, request.body) || !mockRequest.body && !request.body)
    && equal(mockRequest.params, request.params)
    && (equal(mockRequest.headers, request.headers) || !mockRequest.headers && !request.headers);
}

module.exports = {
  matchRequestToMock: matchRequestToMock,
  matchRequestToMockRequest: matchRequestToMockRequest,
};
